












/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { IExtractedArticle } from "../../../Models/ArticleModels/article";
import { SectionModel } from "../../../Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField } from "../../../Models/Components.model";
@Component(
	{
		name: "ArticleSection"
	})
export default class ArticleSection extends Vue {
	@Prop() private value: IExtractedArticle; // your data
	@Prop() private sections: SectionModel[];
	private sectionconfig =
		{
			props: { name: "section", placeholder: "Enter section", label: "Section", required: true } as FormFieldProps,
			rules: { required: true, min_value: 0 } as FormFieldRules
		} as IFormField;
}
